import React, { useState, useEffect } from 'react';
import Navbar from './Components/Common/Navbar.jsx';
import Footer from './Components/Common/Footer.jsx';
import Sidebar from './Components/Common/Sidebar.jsx';
import './CustomAssets/Css/Common/ThemeColorScheme.css';
import './CustomAssets/Css/Common/Main.css';
import './CustomAssets/Css/Pages/Plans.css';
import './CustomAssets/Css/Pages/ContactUs.css';
import './CustomAssets/Css/Pages/AboutUs.css';
import { Toaster } from 'react-hot-toast';

const Layout = ({ children }) => {
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

    const CallSidePanel = (value) => {
        setIsSidePanelOpen(value); 
    };

    return (
        <>
            {/* <div className="preloader">
                <span className="loader"></span>
            </div> */}
            <Toaster />
            <Sidebar isOpen={isSidePanelOpen} setIsOpen={setIsSidePanelOpen} />
            <Navbar CallSidePanel={CallSidePanel} />
            {children}
            <Footer />
        </>
    );
};

export default Layout;
